import products from "./CATALOGO-PRODUCTOS-BAINTEX_02_digital_conPrecios_sinIVA.pdf";
import ditributorGuide from "./GUIA-PARA-DISTRIBUIDORES_BAINTEX_20200806.pdf";

export const PDFs = {
    products,
    ditributorGuide,
};